export const PAGEBUILDER_EDIT_CONTROL_SET_CURRENT_EDITOR = 'PAGEBUILDER.EDIT_CONTROL.SET_CURRENT_EDITOR';
export const PAGEBUILDER_EDIT_CONTROL_START_EDITING = 'PAGEBUILDER.EDIT_CONTROL.START_EDITING';
export const PAGEBUILDER_EDIT_CONTROL_STOP_EDITING = 'PAGEBUILDER.EDIT_CONTROL.STOP_EDITING';
export const PAGEBUILDER_EDIT_CONTROL_RESET_EDITING = 'PAGEBUILDER.EDIT_CONTROL.RESET_EDITING';
